// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from '@/plugins/http/index';
import { getData } from '@/utils/get';


export const getTableSettings = (payload = null) => http.post('apiDashboardCardToolL10n/getTableSettings', payload).then(getData);

export const get = (payload = null) => http.post('apiDashboardCardToolL10n/getRows', payload).then(getData);

export const create = (row) => http.post('apiDashboardCardToolL10n/create', row).then(getData);

export const update = (row) => http.put('apiDashboardCardToolL10n/edit&ID=' + row.ID, row).then(getData);

export const remove = (row) => http.post('apiDashboardCardToolL10n/delete',row).then(getData);

export const getRow = (rowID) => http.get(`apiDashboardCardToolL10n/getRow&ID=${rowID}`).then(getData);

export const getGlossary = () => http.get(`apiDashboardCardToolL10n/getGlossary`).then(getData);
